import { SALARY_FIELDS } from "./constants";

const columns = {
    [SALARY_FIELDS.TARIFF.id]: [
        {
            type: "text",
            title: "_name_",
            label: "_tariff_name_",
            name: "name",
            key: "name",
            isNested: false,
            isKey: true,
            required: true,
            validations: {},
            validationErrors: "",
        },
        {
            type: "distributorType",
            title: "_type_",
            label: "_choose_picture_",
            name: "distributorType",
            key: "distributorType",
            isNested: false,
            isKey: false,
            required: true,
            validations: {},
            validationErrors: "",
        },
        {
            type: "number",
            title: "_fixed_salary_",
            label: "_fixed_salary_",
            name: "baseSalary",
            key: "baseSalary",
            isNested: false,
            isKey: false,
            required: true,
            validations: {
                matchRegexp: /^[0-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
        {
            type: "number",
            title: "_min_orders_count_",
            label: "_min_daily_orders_count_",
            name: "minOrdersCount",
            key: "minOrdersCount",
            isNested: false,
            isKey: false,
            required: true,
            validations: {
                matchRegexp: /^[0-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
        {
            type: "number",
            title: "_min_working_days_",
            label: "_working_days_count_",
            name: "minWorkingDays",
            key: "minWorkingDays",
            isNested: false,
            isKey: false,
            required: true,
            validations: {
                matchRegexp: /^[1-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
    ],
    [SALARY_FIELDS.UNIQUE.id]: [
        {
            type: "number",
            title: "_count_",
            label: "_count_",
            name: "max",
            key: "unique.max",
            isNested: false,
            isKey: false,
            required: true,
            validations: {
                matchRegexp: /^[1-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
        {
            type: "number",
            title: "_price_",
            label: "_price_",
            name: "price",
            key: "unique.price",
            isNested: false,
            isKey: false,
            required: true,
            validations: {
                matchRegexp: /^[1-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
    ],
    [SALARY_FIELDS.SECONDARY.id]: [
        {
            type: "number",
            title: "_count_",
            label: "_count_",
            name: "max",
            key: "secondary.max",
            isNested: false,
            isKey: false,
            required: true,
            validations: {
                matchRegexp: /^[1-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
        {
            type: "number",
            title: "_price_",
            label: "_price_",
            name: "price",
            key: "secondary.price",
            isNested: false,
            isKey: false,
            required: true,
            validations: {
                matchRegexp: /^[1-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
    ],
    [SALARY_FIELDS.BONUS.id]: [
        {
            type: "number",
            title: "_min_count_",
            label: "_min_count_",
            name: "min",
            key: "bonus.min",
            isNested: false,
            isKey: false,
            required: false,
            validations: {
                matchRegexp: /^[1-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
        {
            type: "number",
            title: "_max_count_",
            label: "_max_count_",
            name: "max",
            key: "bonus.max",
            isNested: false,
            isKey: false,
            required: false,
            validations: {
                matchRegexp: /^[1-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
        {
            type: "number",
            title: "_price_",
            label: "_price_",
            name: "price",
            key: "bonus.price",
            isNested: false,
            isKey: false,
            required: false,
            validations: {
                matchRegexp: /^[1-9]\d*$/,
            },
            validationErrors: {
                matchRegexp: "_min_number_error_",
            },
        },
    ],
    [SALARY_FIELDS.PAYMENT.id]: [
        {
            title: "_months_",
            key: "date",
            canChange: {
                type: "date",
            },
        },
        {
            title: "_amount_",
            key: "amount",
            canChange: {
                type: "text",
                validations: {
                    matchRegexp: /^[1-9]\d*$/,
                },
                validationErrors: {
                    matchRegexp: "_min_number_error_",
                },
            },
        },
        {
            title: "_comment_",
            key: "comment",
            canChange: {
                type: "text",
            },
        },
    ],
    [SALARY_FIELDS.HISTORY.id]: [
        {
            title: "_distributor_",
            key: "distributorId",
            format: "distributorId",
            isNested: false,
            isKey: true,
            dataSort: true,
        },
        {
            title: "_send_act_",
            key: "sendAct",
            format: "sendAct",
            isNested: false,
            isKey: false,
            dataSort: false,
        },
        {
            title: "_tariff_",
            key: "tariffId.name",
            format: "tariffId.name",
            isNested: true,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_individual_entrepreneur_name_",
            key: "distributorId.individualEntrepreneurName",
            format: "distributorId.individualEntrepreneurName",
            isNested: true,
            isKey: false,
            dataSort: false,
        },
        {
            title: "_taxpayer_identification_number_",
            key: "distributorId.taxpayerIdentificationNumber",
            format: "distributorId.taxpayerIdentificationNumber",
            isNested: true,
            isKey: false,
            dataSort: false,
        },
        {
            title: "_total_count_",
            key: "totalOrdersCount",
            format: "totalOrdersCount",
            isNested: false,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_unique_",
            key: "uniqueOrdersCount",
            format: "uniqueOrdersCount",
            isNested: false,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_secondary_",
            key: "secondaryOrdersCount",
            format: "secondaryOrdersCount",
            isNested: false,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_actual_working_days_",
            key: "actualWorkingDays",
            format: "actualWorkingDays",
            isNested: false,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_bonus_",
            key: "calculatedSalary.bonus",
            format: "calculatedSalary.bonus",
            isNested: true,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_base_salary_",
            key: "calculatedSalary.base",
            format: "calculatedSalary.base",
            isNested: true,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_calculated_salary_",
            key: "totalSalary",
            format: "totalSalary",
            isNested: false,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_payed_salary_",
            key: "payedSalaries",
            format: "payedSalaries",
            isNested: false,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_transferred_salary_",
            key: "salaryToBeTransferred",
            format: "salaryToBeTransferred",
            isNested: false,
            isKey: false,
            dataSort: true,
        },
        {
            title: "_comments_",
            key: "payedSalaries",
            format: "comments",
            isNested: false,
            isKey: false,
            dataSort: true,
        },
    ],
};
export default {
    getColumns(fieldId) {
        return [...columns[fieldId]];
    },
};
